import React, { useEffect, useState, useRef } from "react";
import { Input } from "@/components/ui/input";

/**
 * Brazilian currency input. Stores numeric value (reais, e.g. 3990.5).
 * Displays as "R$ 3.990,50". User types raw digits — last 2 are cents.
 */
export default function CurrencyInput({ value, onChange, ...props }) {
  const formatBRL = (cents) => {
    const n = Number(cents) / 100;
    return new Intl.NumberFormat("pt-BR", {
      style: "currency", currency: "BRL", minimumFractionDigits: 2,
    }).format(n);
  };

  const valueToCents = (v) => {
    if (v == null || v === "") return 0;
    const n = Number(v);
    if (isNaN(n)) return 0;
    return Math.round(n * 100);
  };

  const [display, setDisplay] = useState(() => formatBRL(valueToCents(value)));

  // Sync if external value changes
  useEffect(() => {
    setDisplay(formatBRL(valueToCents(value)));
  }, [value]);

  const handleChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "");
    const cents = raw === "" ? 0 : parseInt(raw, 10);
    setDisplay(formatBRL(cents));
    onChange(cents / 100);
  };

  return (
    <Input
      inputMode="numeric"
      value={display}
      onChange={handleChange}
      {...props}
    />
  );
}
